import { render, staticRenderFns } from "./cartDetail.vue?vue&type=template&id=4052b0bd&scoped=true&"
import script from "./cartDetail.vue?vue&type=script&lang=js&"
export * from "./cartDetail.vue?vue&type=script&lang=js&"
import style1 from "./cartDetail.vue?vue&type=style&index=1&id=4052b0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4052b0bd",
  null
  
)

export default component.exports